import React from 'react';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
import { ChevronLeft, ChevronRight, Plus } from 'lucide-react';
const TEAM_TABS = [{
  label: 'Shift Planner',
  path: ''
}, {
  label: 'Leave Timeline',
  path: 'leave'
}, {
  label: 'Team Directory',
  path: 'directory'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}];
const LEAVE_STATS = [{
  label: 'On Vacation',
  count: 1,
  sub: 'Nuran is away',
  icon: '🏖️'
}, {
  label: 'Sick Today',
  count: 0,
  sub: 'Full health',
  icon: '🤒'
}, {
  label: 'Personal',
  count: 0,
  sub: 'Approved days',
  icon: '📅'
}, {
  label: 'Coverage',
  count: 'Good',
  sub: '1 unavailable',
  icon: '✓'
}];
const EMPLOYEES = [{
  name: 'Antonina J.',
  role: 'Voda smene',
  initials: 'AJ',
  color: 'bg-green-500',
  vacationUsed: 10,
  vacationTotal: 20,
  sick: 2,
  personal: 1,
  personalTotal: 5,
  leaves: [{
    start: 5,
    end: 12,
    type: 'vacation'
  }]
}, {
  name: 'Jasmina N.',
  role: 'Voda smene',
  initials: 'JN',
  color: 'bg-red-500',
  vacationUsed: 5,
  vacationTotal: 20,
  sick: 5,
  personal: 0,
  personalTotal: 5,
  leaves: [{
    start: 22,
    end: 23,
    type: 'sick'
  }]
}, {
  name: 'Naveen',
  role: 'Kuvar',
  initials: 'N',
  color: 'bg-orange-500',
  vacationUsed: 0,
  vacationTotal: 20,
  sick: 0,
  personal: 1,
  personalTotal: 5,
  leaves: [{
    start: 24,
    end: 24,
    type: 'personal'
  }]
}, {
  name: 'Nuran',
  role: 'Kuvar',
  initials: 'Nu',
  color: 'bg-purple-500',
  vacationUsed: 15,
  vacationTotal: 20,
  sick: 0,
  personal: 0,
  personalTotal: 5,
  leaves: [{
    start: 8,
    end: 28,
    type: 'vacation'
  }]
}];
const WEEKS = [{
  label: 'W48',
  sub: '1-7 Dec'
}, {
  label: 'W49',
  sub: '8-14 Dec'
}, {
  label: 'W50',
  sub: '15-21 Dec'
}, {
  label: 'W51',
  sub: '22-28 Dec'
}, {
  label: 'W52',
  sub: '29 Dec-4 Jan'
}];
export function LeaveTimeline() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2184">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-2185">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-2186">Leave Timeline</h1>
        <Button icon={<Plus size={16} data-id="element-2188" />} data-id="element-2187">Add Leave</Button>
      </div>

      <OperationsSwitcher data-id="element-2189" />

      <TabNavigation tabs={TEAM_TABS} basePath="/operations/team" data-id="element-2190" />

      {/* Stats Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2191">
        {LEAVE_STATS.map(stat => <Card key={stat.label} className="p-4" data-id="element-2192">
            <div className="flex justify-between items-start" data-id="element-2193">
              <span className="text-2xl" data-id="element-2194">{stat.icon}</span>
              <div className="text-right" data-id="element-2195">
                <div className="text-2xl font-bold" data-id="element-2196">{stat.count}</div>
                <div className="text-xs text-text-secondary" data-id="element-2197">{stat.sub}</div>
              </div>
            </div>
            <div className="mt-2 font-medium text-sm text-text-secondary" data-id="element-2198">
              {stat.label}
            </div>
          </Card>)}
      </div>

      {/* Timeline Grid */}
      <Card className="overflow-hidden" noPadding data-id="element-2199">
        <div className="p-4 border-b border-white/10 flex items-center justify-between bg-background-elevated" data-id="element-2200">
          <h3 className="font-bold" data-id="element-2201">December 2025</h3>
          <div className="flex items-center gap-4" data-id="element-2202">
            <button className="p-1 hover:bg-white/10 rounded" data-id="element-2203">
              <ChevronLeft size={20} data-id="element-2204" />
            </button>
            <span className="font-medium" data-id="element-2205">Dec 2025</span>
            <button className="p-1 hover:bg-white/10 rounded" data-id="element-2206">
              <ChevronRight size={20} data-id="element-2207" />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-2208">
          <div className="min-w-[800px]" data-id="element-2209">
            {/* Header */}
            <div className="grid grid-cols-[200px_1fr] border-b border-white/10" data-id="element-2210">
              <div className="p-4 font-medium text-text-secondary border-r border-white/10" data-id="element-2211">
                EMPLOYEE
              </div>
              <div className="grid grid-cols-5" data-id="element-2212">
                {WEEKS.map(week => <div key={week.label} className="p-2 text-center border-r border-white/5 last:border-r-0" data-id="element-2213">
                    <div className="text-sm font-bold" data-id="element-2214">{week.label}</div>
                    <div className="text-xs text-text-secondary" data-id="element-2215">
                      {week.sub}
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Rows */}
            {EMPLOYEES.map(emp => <div key={emp.name} className="grid grid-cols-[200px_1fr] border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-2216">
                <div className="p-4 flex items-center gap-3 border-r border-white/10" data-id="element-2217">
                  <div className={`w-8 h-8 rounded-full ${emp.color} flex items-center justify-center text-white text-xs font-bold`} data-id="element-2218">
                    {emp.initials}
                  </div>
                  <div data-id="element-2219">
                    <div className="font-medium text-sm" data-id="element-2220">{emp.name}</div>
                    <div className="text-xs text-text-secondary" data-id="element-2221">
                      {emp.role}
                    </div>
                  </div>
                </div>
                <div className="relative h-16" data-id="element-2222">
                  {/* Grid lines */}
                  <div className="absolute inset-0 grid grid-cols-5 pointer-events-none" data-id="element-2223">
                    {[0, 1, 2, 3, 4].map(i => <div key={i} className="border-r border-white/5 h-full" data-id="element-2224"></div>)}
                  </div>

                  {/* Leave Bars */}
                  {emp.leaves.map((leave, i) => {
                // Simplified positioning logic for demo
                const left = `${leave.start * 3}%`;
                const width = `${(leave.end - leave.start) * 3}%`;
                const colors = {
                  vacation: 'bg-accent-success',
                  sick: 'bg-accent-error',
                  personal: 'bg-blue-500'
                };
                return <div key={i} className={`absolute top-1/2 -translate-y-1/2 h-3 rounded-full ${colors[leave.type as keyof typeof colors]} opacity-80`} style={{
                  left,
                  width
                }} data-id="element-2225"></div>;
              })}
                </div>
              </div>)}
          </div>
        </div>
      </Card>

      {/* Balances Table */}
      <Card noPadding data-id="element-2226">
        <div className="p-4 border-b border-white/10 font-bold" data-id="element-2227">
          Leave Balances (2025)
        </div>
        <div className="overflow-x-auto" data-id="element-2228">
          <table className="w-full text-sm" data-id="element-2229">
            <thead data-id="element-2230">
              <tr className="text-text-secondary border-b border-white/5" data-id="element-2231">
                <th className="text-left p-4" data-id="element-2232">EMPLOYEE</th>
                <th className="text-left p-4 w-1/3" data-id="element-2233">VACATION USED</th>
                <th className="text-center p-4" data-id="element-2234">REMAINING</th>
                <th className="text-center p-4" data-id="element-2235">SICK DAYS</th>
                <th className="text-center p-4" data-id="element-2236">PERSONAL DAYS</th>
              </tr>
            </thead>
            <tbody data-id="element-2237">
              {EMPLOYEES.map(emp => <tr key={emp.name} className="border-b border-white/5 hover:bg-white/5" data-id="element-2238">
                  <td className="p-4" data-id="element-2239">
                    <div className="flex items-center gap-3" data-id="element-2240">
                      <div className={`w-8 h-8 rounded-full ${emp.color} flex items-center justify-center text-white text-xs font-bold`} data-id="element-2241">
                        {emp.initials}
                      </div>
                      <span className="font-medium" data-id="element-2242">{emp.name}</span>
                    </div>
                  </td>
                  <td className="p-4" data-id="element-2243">
                    <div className="flex items-center gap-3" data-id="element-2244">
                      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden" data-id="element-2245">
                        <div className="h-full bg-accent-success" style={{
                      width: `${emp.vacationUsed / emp.vacationTotal * 100}%`
                    }} data-id="element-2246"></div>
                      </div>
                      <span className="text-xs tabular-nums" data-id="element-2247">
                        {emp.vacationUsed}/{emp.vacationTotal}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 text-center" data-id="element-2248">
                    <span className="px-2 py-1 bg-accent-success/20 text-accent-success rounded text-xs font-bold" data-id="element-2249">
                      {emp.vacationTotal - emp.vacationUsed} days
                    </span>
                  </td>
                  <td className="p-4 text-center tabular-nums" data-id="element-2250">
                    {emp.sick} days
                  </td>
                  <td className="p-4 text-center tabular-nums" data-id="element-2251">
                    {emp.personal}/{emp.personalTotal}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}